(function ($) {
    'use strict';
    
    $(document).ready(function () {
        let speed = 50000;
        let width = window.innerWidth;
        if(width < 480) {
            speed = 8000;
        } else if(width < 767) {
            speed = 8000;
        } else if(width < 1200) {
            speed = 50000;
        }
        $('.logo-slider-v2__marquee').marquee({
            duration: speed,
            gap: 0,
            pauseOnHover: true,
            duplicated: true,
            delayBeforeStart: 0,
            startVisible: true
        });
    });

})(jQuery);

